// Description: This file contains the TpInstanceService class which is responsible for handling API calls related to TP instances.
import React from 'react';
import AuthService from './authService.js';

export default class TpInstanceService extends React.Component {
  static async GetThirdPartyInstanceList() {
    return AuthService
      .getInstance()
      .CallBackendFunction('/api/TpInstance/GetTpInstances/?clearCache=false');
  }

  
}

